import React from 'react';
import { Button, Group } from '@economic/gaudi';
import { t } from '../../../../../shared/components/l10n/l10n';
import { languages } from '../util';
import { WizardCheckbox } from './WizardCheckbox';

export const Step2 = ({ onBack, onNext, values }) => {
    const valid = values.languages && (values.languages.da || values.languages.en);

    return (
        <div className="flex flex-col items-center">
            <h1 className="text-center">{t`USER_PANEL_STEP_LANGUAGES_TITLE`}</h1>
            <h5 className="font-bold text-center w-3/4">{t`USER_PANEL_STEP_LANGUAGES_INFORMATION_1`}</h5>
            <p>{t`USER_PANEL_STEP_LANGUAGES_INFORMATION_2`}</p>

            {Object.keys(languages).map(language => (
                <React.Fragment key={language}>
                    <WizardCheckbox
                        text={t(languages[language])}
                        name={`languages.${language}`}
                        checked={values.languages && values.languages[language]}
                        className="justify-center"
                    />
                </React.Fragment>
            ))}

            <Group className="form__buttons">
                {onNext ? (
                    <>
                        <Button appearance="primary" disabled={!valid} onClick={() => onNext()}>
                            {t`BUTTON_NEXT`}
                        </Button>
                        <Button appearance="discrete" onClick={onBack}>
                            {t`BUTTON_BACK`}
                        </Button>
                    </>
                ) : (
                    <Button appearance="primary" disabled={!valid} type="submit">{t`BUTTON_SAVE`}</Button>
                )}
            </Group>
        </div>
    );
};
